<!-- <ng-template #name></ng-template> -->
<ng-template>
  <ng-content></ng-content>
</ng-template>
